export function defaultElementPosition(point: number[] = [0, 0]): number[] {
  return [point[0]! + 50, point[1]!];
}

export function rotateLayoutOffset(point: number[], degrees = 0): number[] {
  const radians = degrees * Math.PI / 180;
  const cosine = Math.cos(radians);
  const sine = Math.sin(radians);
  return [point[0]! * cosine - point[1]! * sine, point[0]! * sine + point[1]! * cosine];
}

export function layoutCanvasPoint(point: number[], origin: number[], rotation = 0): number[] {
  const offset = rotateLayoutOffset(point, rotation);
  return [origin[0]! + offset[0]!, origin[1]! + offset[1]!];
}

export function layoutLocalPoint(point: number[], origin: number[], rotation = 0): number[] {
  const offset = [point[0]! - origin[0]!, point[1]! - origin[1]!];
  return rotateLayoutOffset(offset, -rotation);
}
